export class UpdateMealCategoryItemEntity {
  addedItems?: Array<{
    itemId: number
  }> | null
  removedItems?: Array<{
    itemId: number
  }> | null
}
